import React from 'react';
import heroImage from '../assets/HaulRadarCover.gif'; // Adjust the path as needed

const Hero = () => {
  return (
    <section 
      className="relative bg-cover bg-center h-screen overflow-hidden" 
      style={{ backgroundImage: `url(${heroImage})` }}
    >
      {/* Apply the blur effect to the background */}
      <div className="absolute inset-0 bg-black opacity-60 backdrop-blur-xl"></div> 

      {/* Overlay content */}
      <div className="relative z-10 container mx-auto h-full flex flex-col justify-center items-center text-center text-white">
        <h1 className="text-4xl md:text-6xl font-bold">Keep Your Trucks Moving</h1>
        <p className="text-xl md:text-2xl mt-4">Increase Job Site Productivity with HaulRadar</p>
        <a href="https://dashboard.haulradar.com/sign-up" className="mt-6 bg-black text-white font-bold py-2 px-4 rounded-full hover:bg-white hover:text-black">
          Create an account
        </a>
      </div>
    </section>
  );
};

export default Hero;
